<template>
  <button
    dir="rtl"
    @click="$emit('action')"
    :class="theme ? theme : 'btnL2 w-5/12'"
  >
    <h1 v-if="text" class="btnTxt first-letter:uppercase">{{ text }}</h1>
    <svg-app :type="svg" />
  </button>
</template>

<script>
import svgApp from "@/components/svgApp.vue";

export default {
  components: { svgApp },
  props: {
    theme: String,
    text: String,
    svg: String,
  },
};
</script>
